module.exports = __webpack_public_path__ + "assets/images/magnifying-glass-icon.87825f92675c3f29b3094cda1d732ecf.svg";